import { useEffect } from "react";
import { motion } from "framer-motion";
import Logo from "./Logo";
import { EASE } from "./Reveal";

const WORD = "COLLANMORE";

export default function Preloader() {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    if (window.__lenis) window.__lenis.stop();
    return () => {
      document.body.style.overflow = "";
      if (window.__lenis) window.__lenis.start();
    };
  }, []);

  return (
    <motion.div
      data-testid="preloader"
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-navy"
      exit={{ clipPath: "inset(0 0 100% 0)" }}
      transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.85 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.9, ease: EASE }}
      >
        <Logo className="h-16 w-16" />
      </motion.div>
      <div className="mt-8 overflow-hidden">
        <div className="flex">
          {WORD.split("").map((ch, i) => (
            <motion.span
              key={i}
              className="font-display text-2xl tracking-[0.35em] text-ivory md:text-3xl"
              initial={{ y: "120%", opacity: 0 }}
              animate={{ y: "0%", opacity: 1 }}
              transition={{ duration: 0.8, ease: EASE, delay: 0.25 + i * 0.045 }}
            >
              {ch}
            </motion.span>
          ))}
        </div>
      </div>
      <motion.p
        className="mt-3 text-[11px] uppercase tracking-widest2 text-gold-2"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.9 }}
      >
        Island Lodge
      </motion.p>
      <div className="mt-10 h-px w-40 overflow-hidden bg-ivory/10">
        <motion.div
          className="h-full bg-gold"
          initial={{ width: "0%" }}
          animate={{ width: "100%" }}
          transition={{ duration: 1.7, ease: "easeInOut" }}
        />
      </div>
    </motion.div>
  );
}
